<div class="insight-container">
  <div class="insight-title">
    <div class="insight-title-icon" (click)="onClose(false)"><mat-icon>close</mat-icon></div>
  </div>
  <div class="insight-title-main">Are you sure?</div>
  <div class="insight-content">
    <div class="insight-text">
        This will change the AI’s confidence status. Do you want to continue?
    </div>
    <mat-dialog-actions>
      <button mat-button class="cra-button button-light" (click)="onClose(false)">Cancel</button>
      <button mat-button class="cra-button button-dark" (click)="onClose(true)">Confirm</button>
    </mat-dialog-actions>
  </div>
</div>
